import React, { useEffect, useState } from 'react';

export const DispatchMonitor = () => {
  const [queues, setQueues] = useState({ searching: 0, offering: 0, retrying: 0, failed: 0 });

  useEffect(() => {
    const interval = setInterval(() => {
      // Replace with actual Firestore counts on dispatchState
      setQueues({ searching: 3, offering: 2, retrying: 1, failed: 0 });
    }, 5000);
    return () => clearInterval(interval);
  }, []);

  return (
    <div className="bg-gray-800 rounded-lg p-4">
      <h3 className="font-semibold mb-3">Dispatch Monitor</h3>
      <div className="space-y-2">
        <div className="flex justify-between items-center">
          <span className="text-sm text-gray-400">Searching</span>
          <span className="text-white font-mono">{queues.searching}</span>
        </div>
        <div className="flex justify-between items-center">
          <span className="text-sm text-gray-400">Offering</span>
          <span className="text-white font-mono">{queues.offering}</span>
        </div>
        <div className="flex justify-between items-center">
          <span className="text-sm text-gray-400">Retrying</span>
          <span className="text-yellow-400 font-mono">{queues.retrying}</span>
        </div>
        <div className="flex justify-between items-center">
          <span className="text-sm text-gray-400">Failed</span>
          <span className="text-red-400 font-mono">{queues.failed}</span>
        </div>
      </div>
    </div>
  );
};
